import { useState } from "react";
import { Eyebrow, CopyButton } from "@/components/shared";

const docs = [
  ["getting-started", "Getting Started", "Create your ZettaKeep account, deploy a backup server, and connect Proxmox VE — all in a few minutes.", null],
  ["connect", "Connect Proxmox VE", "In the Proxmox web UI go to Datacenter → Storage → Add → Proxmox Backup Server, then enter the values from your ZettaKeep server page. Or use the CLI:", "pvesm add pbs zettakeep --server <host> --datastore zk-datastore \\\n  --username '<token-id>' --password '<secret>' --fingerprint '<fp>'"],
  ["backup-job", "Create a Backup Job", "In Datacenter → Backup → Add, select your ZettaKeep storage as the target, choose your guests and schedule.", null],
  ["retention", "Retention", "Pruning keeps a configurable number of daily/weekly/monthly backups. Configure it on your server page or pick a preset during deployment.", null],
  ["encryption", "Encryption", "Enable Proxmox client-side encryption to keep your key private. ZettaKeep never stores your encryption key. Generate a key:", "proxmox-backup-client key create --kdf none /root/zk.key"],
  ["restore", "Restore a Backup", "Browse snapshots in the Restore Center, then restore through Proxmox: select the storage, pick the snapshot, and restore the VM/CT.", "qmrestore <storage>:backup/vm/<vmid>/<time> <newid>"],
  ["wireguard", "WireGuard", "Create a tunnel on your server page, download the .conf file (or scan the QR code), and bring it up:", "wg-quick up zettakeep"],
  ["firewall", "Firewall", "ZettaKeep is default-deny. Only the PBS API/backup port is exposed, and you can add an IP allowlist on your server page.", null],
  ["api-tokens", "API Tokens", "Each server has a scoped, bucket-restricted API token. Rotate it any time from the server page — old credentials are revoked immediately.", null],
  ["storage", "Storage", "You're billed on reserved storage. Expand instantly from the server page — proration is handled automatically.", null],
  ["billing", "Billing", "Manage your subscription, invoices and payment method from the Billing page, powered by Stripe.", null],
  ["troubleshooting", "Troubleshooting", "Run the connection test from your server page. It checks DNS, TCP/8007, TLS, fingerprint, auth, datastore, latency and throughput.", null],
  ["disaster-recovery", "Disaster Recovery", "If your entire Proxmox host is gone: reinstall Proxmox VE, add ZettaKeep as PBS storage, retrieve your encryption key, browse snapshots, and restore.", null],
];

export default function Docs() {
  const [active, setActive] = useState(docs[0][0]);
  const doc = docs.find((d) => d[0] === active);
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <Eyebrow>Documentation</Eyebrow>
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-50">Docs</h1>
      <div className="mt-10 grid gap-8 lg:grid-cols-[240px_1fr]">
        <nav className="space-y-1">
          {docs.map(([id, title]) => (
            <button key={id} onClick={() => setActive(id)} data-testid={`doc-nav-${id}`}
              className={`block w-full rounded-lg px-3 py-2 text-left text-sm transition-colors ${active === id ? "bg-cyan-500/10 text-cyan-300" : "text-slate-400 hover:bg-slate-900 hover:text-slate-200"}`}>
              {title}
            </button>
          ))}
        </nav>
        <article className="rounded-2xl border border-slate-800 bg-slate-900/40 p-8">
          <h2 className="font-display text-2xl font-bold text-slate-100">{doc[1]}</h2>
          <p className="mt-4 text-slate-300">{doc[2]}</p>
          {doc[3] && (
            <div className="mt-5 rounded-lg border border-slate-800 bg-slate-950 p-4">
              <div className="mb-2 flex justify-end"><CopyButton value={doc[3]} label="Command" testid="doc-copy" /></div>
              <pre className="overflow-x-auto whitespace-pre-wrap font-mono text-sm text-cyan-300">{doc[3]}</pre>
            </div>
          )}
        </article>
      </div>
    </div>
  );
}
